import { render, staticRenderFns } from "./guessTable2.vue?vue&type=template&id=53b6b8b8&"
import script from "./guessTable2.vue?vue&type=script&lang=js&"
export * from "./guessTable2.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports